import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import useCustomTheme from "expert-web-app/src/utils/hooks/useCustomTheme";

const NoAnnouncementsScreen = ({ t, classes }) => {
    const theme = useCustomTheme();

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.noAnnouncement}>
                <Typography variant="body2" color="textPrimary">
                    {t("No Announcements")}
                </Typography>
            </div>
        </ThemeProvider>
    );
};

NoAnnouncementsScreen.propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired
};

export default NoAnnouncementsScreen;
